import { isEmpty } from 'lodash';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

export const useShowPopupOtherAgenda = (fields) => {
  const history = useHistory();
  const [isShowPopupSaveAgenda, setIsShowPopupSaveAgenda] = useState(false);
  const [navigatingPathname, setNavigatingPathname] = useState('');

  const handleKeepNavigate = (pathName) => {
    if (pathName) {
      history.push(pathName);
    } else {
      history.push(navigatingPathname);
    }
  };

  useEffect(() => {
    if (isEmpty(fields)) return;
    const unblock = history.block((location) => {
      if (isShowPopupSaveAgenda) {
        return;
      }
      setNavigatingPathname(location.pathname);
      setIsShowPopupSaveAgenda(true);
      return false;
    });

    return () => {
      unblock();
    };
  }, [history, fields, isShowPopupSaveAgenda]);

  return {
    isShowPopupSaveAgenda,
    handleKeepNavigate,
    setIsShowPopupSaveAgenda,
    navigatingPathname,
  };
};
